import {Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DxSelectBoxModule, DxValidatorModule} from "devextreme-angular";
import {AssetType, DataSources} from "@services";

@Component({
    selector: 'app-asset-select',
    standalone: true,
    imports: [
        CommonModule,
        DxSelectBoxModule,
        DxValidatorModule
    ],
    template: `
        <dx-select-box
            [(value)]="value"
            (valueChange)="valueChange.emit($event)"
            [dataSource]="dataSource"
            valueExpr="id"
            displayExpr="name"
            stylingMode="filled"
            [placeholder]="placeholder"
            [searchEnabled]="true"
            [readOnly]="readOnly"
            (onValueChanged)="onValueChanged.emit($event)"
            [showClearButton]="showClearButton"
        >
            <dx-validator>
                @if (isRequired) {
                    <dxi-validation-rule type="required" [message]="requiredMessage"></dxi-validation-rule>
                }
            </dx-validator>
        </dx-select-box>
    `
})
export class AssetSelectComponent implements OnChanges {
    private dataSourcesService = inject(DataSources);

    @Input() value: any;
    @Output() valueChange = new EventEmitter<any>();

    @Input({required: true}) assetType: AssetType | null | undefined;
    @Input() placeholder: string = 'Select Asset';
    @Input() readOnly: boolean = false;
    @Input() showClearButton: boolean = false;
    @Output() onValueChanged = new EventEmitter<any>();

    @Input() isRequired: boolean = false;
    @Input() requiredMessage: string = 'Value is required';

    dataSource: any;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['assetType']) {
            this.loadDataSource();
        }
    }

    private loadDataSource() {
        if (this.assetType) {
            this.dataSource = this.dataSourcesService.assetOptions(this.assetType, false);
        } else {
            this.dataSource = null;
        }
    }
}
